import React, { createContext, useContext, useEffect, useState } from "react";
import { WindowLocation } from "@reach/router";

interface AppContextProps {
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
  animating: boolean;
  setAnimating: (open: boolean) => void;
}

interface AppContainerProps {
  location: WindowLocation;
}

const AppContext = createContext<AppContextProps>({
  navOpen: false,
  setNavOpen: () => false,
  animating: true,
  setAnimating: () => false,
});

const AppContainer: React.FC<AppContainerProps> = ({ children, location }) => {
  const [navOpen, setNavOpen] = useState<boolean>(false);
  const [animating, setAnimating] = useState<boolean>(true);

  useEffect(() => {
    setNavOpen(false);
  }, [location]);

  const value = {
    navOpen,
    setNavOpen,
    animating,
    setAnimating,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

const useAppContext = (): AppContextProps => useContext(AppContext);

export { AppContainer, useAppContext };
